$(function() {
	var dataUrl = "";
	var link;

	var overlay = $('#overlay');
	$('a[data-overlay]').on('click', function(event) {
		event.preventDefault();

		link = $(this);
		dataUrl = $(this).attr('data-overlay');

		$('body').addClass('show-overlay');

		$.ajax({
			url: dataUrl,
			success: success,
			error: error
		});
	});

	$('#overlay .close').on('click', function(event) {
		event.preventDefault();
		$('body').removeClass('show-overlay');
	});

	function success(data) {
		//overlay.html("<h1>Hello World</h1>");
		overlay.html(data);
	}

	function error(error) {
		window.location.href = link.attr('href');
	}
});


/** WEBPACK FOOTER **
 ** ./Frontend/js/modules/overlay/index.js
 **/